import TFacturas from "./TFacturas"
import { obtenerFacturasAceptadasAction } from "./../../../ducks/facturacionAceptadasDuck"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

const VDevoluciones = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerFacturasAceptadasAction())
    },[])
    return (
        <div>
            <TFacturas />
        </div>
    )
}
export default VDevoluciones